// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Cta-cls1___c89f24d3a83ad9894ab{/*!*/}.Cta-cls2__d51b34993c905f86de5c{display:flex;flex-direction:column;width:100%;grid-gap:2px;gap:2px;background:none;border:none;cursor:pointer;margin:0;padding:6px 8px}.Cta-cls2__d51b34993c905f86de5c:hover{background-color:#f8f8fb}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Cta-cls1___c89f24d3a83ad9894ab",
	"cls2": "Cta-cls2__d51b34993c905f86de5c Cta-cls1___c89f24d3a83ad9894ab"
};
export default ___CSS_LOADER_EXPORT___;
